"use client";

import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import useMediaQuery from "@/hooks/useMediaQuery";
import { Package } from "@/types/packages/data-only/DataOnlyCountryPackages";
import PackageDetail from "./PackageDetail";

interface PropsType {
  packageDetail: Package;
  children?: React.ReactNode;
  index?: number;
  countryFlag: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

function PackageDetailModal({
  packageDetail,
  children,
  index = 1,
  countryFlag,
  open,
  onOpenChange,
}: PropsType) {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const isControlled = open !== undefined;

  const detailContent = (
    <PackageDetail packageDetail={packageDetail} countryFlag={countryFlag} />
  );

  return (
    <>
      {/* this div is just for seo  */}
      {index === 0 && <div className="sr-only">{detailContent}</div>}

      {isDesktop ? (
        <Dialog open={open} onOpenChange={onOpenChange}>
          {children && !isControlled && (
            <DialogTrigger className="group flex items-center gap-3 text-xs text-primary">
              {children}
            </DialogTrigger>
          )}
          {(isControlled || children) && (
            <DialogContent
              className="flex max-h-[90vh] flex-col gap-3 overflow-auto scrollbar-thin sm:gap-5"
              onOpenAutoFocus={(event) => event.preventDefault()}
            >
              {detailContent}
            </DialogContent>
          )}
        </Dialog>
      ) : (
        <Drawer
          repositionInputs={false}
          open={open}
          onOpenChange={onOpenChange}
        >
          {children && !isControlled && (
            <DrawerTrigger className="group flex items-center gap-3 text-xs text-primary">
              {children}
            </DrawerTrigger>
          )}
          {(isControlled || children) && (
            <DrawerContent className="grid max-h-[94%] grid-rows-[auto_1fr]">
              <div className="flex flex-col gap-3 overflow-auto p-3 sm:gap-6">
                {detailContent}
              </div>
            </DrawerContent>
          )}
        </Drawer>
      )}
    </>
  );
}

export default PackageDetailModal;
